export default { CIVILITY: 'field5', WIZVILLE: "'wizvilleentryLink'" };
